import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c75ee2f6")

_pushScopeId("data-v-c75ee2f6")
const _hoisted_1 = { class: "side-list-item-root" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "icon icon-video" }, null, -1)
const _hoisted_4 = { class: "map-and-prediction" }
const _hoisted_5 = { class: "prediction-summary" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_multi_prediction = _resolveComponent("multi-prediction")
  const _component_road_map_view = _resolveComponent("road-map-view")
  const _component_multi_bet_view = _resolveComponent("multi-bet-view")
  const _component_multi_card_result = _resolveComponent("multi-card-result")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", {
        class: ["timer", _ctx.timerClass]
      }, _toDisplayString(_ctx.currentTime), 3),
      _createVNode("span", null, _toDisplayString(_ctx.title), 1),
      _createVNode("span", null, "局数 " + _toDisplayString(_ctx.shoe) + " - " + _toDisplayString(_ctx.juNo), 1),
      _createVNode("span", null, "编号 " + _toDisplayString(_ctx.gameNo), 1),
      _createVNode("span", {
        class: "btn-enter",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.enterTable && _ctx.enterTable(...args)))
      }, _toDisplayString(_ctx.iN('common.enterthistable')), 1),
      _createVNode("div", {
        class: "btn-video",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.OnClickVideo && _ctx.OnClickVideo(...args)))
      }, [
        _hoisted_3,
        _createVNode("span", null, _toDisplayString(_ctx.iN('common.video')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_multi_prediction, {
          class: "pre",
          color: 2,
          preType: 1,
          label: _ctx.gameType === 'G002' ? '庄问路' : '龙问路',
          onOnpredict: _ctx.handleOnPredict,
          preData: _ctx.nextRedRoadMapSummaryData
        }, null, 8, ["label", "onOnpredict", "preData"]),
        _createVNode(_component_multi_prediction, {
          class: "pre",
          color: 1,
          preType: 2,
          label: _ctx.gameType === 'G002' ? '闲问路' : '虎问路',
          preData: _ctx.nextBlueRoadMapSummaryData,
          onOnpredict: _ctx.handleOnPredict
        }, null, 8, ["label", "preData", "onOnpredict"])
      ]),
      _createVNode(_component_road_map_view, {
        class: "road-map",
        display: _ctx.roadmapDisplay,
        gameType: _ctx.gameType,
        mapData: _ctx.deskResult,
        showActiveAndInActive: true,
        predictionEnabled: true,
        beadRowsCount: 12,
        onRoadMapData: _ctx.OnRoadMapData,
        ref: "roadmapview"
      }, null, 8, ["display", "gameType", "mapData", "onRoadMapData"])
    ]),
    _createVNode(_component_multi_bet_view, {
      class: "bet-view",
      s6Mode: _ctx.isSuper6Mode,
      gameType: _ctx.gameType,
      allowBet: _ctx.allowBet,
      chipValue: _ctx.chipAmount,
      currentDesk: _ctx.deskData,
      ref: "betview"
    }, null, 8, ["s6Mode", "gameType", "allowBet", "chipValue", "currentDesk"]),
    (_ctx.showResult)
      ? (_openBlock(), _createBlock(_component_multi_card_result, {
          key: 0,
          class: "card-result",
          gameType: _ctx.gameType,
          gameResult: _ctx.currentGameResult,
          offSound: true
        }, null, 8, ["gameType", "gameResult"]))
      : _createCommentVNode("", true)
  ]))
})